import React from "react";
import { AltLayout } from "../common";

import DrEventsAdmin from "./dr-events-admin";

const DemandResponsePage = () => {
  return (
    <AltLayout pageTitle="Demand Response">
      <DrEventsAdmin></DrEventsAdmin>
    </AltLayout>
  );
};

export default DemandResponsePage;
